import { render, staticRenderFns } from "./AbstractRegisterTopBar.vue?vue&type=template&id=56901944&"
import script from "./AbstractRegisterTopBar.vue?vue&type=script&lang=js&"
export * from "./AbstractRegisterTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports